import React, { useState, useContext, createContext, useEffect } from 'react';

import { Gacha } from '@/api-client/generated/models';
import { createApiClientWithToken } from '@/service/PreRegistrationApiFactory';

type GachaContextType = {
  gacha: Gacha;
  fetchGacha: Function;
};

const GachaContext = createContext<GachaContextType>({ gacha: null, fetchGacha: () => {} });

export const useGacha = () => useContext(GachaContext);

interface GachaProviderProps {
  gachaId: string;
  children: React.ReactNode;
}
export default function GachaProvider({ gachaId, children }: GachaProviderProps): JSX.Element {
  const [gacha, setGacha] = useState<Gacha | null>(null);

  const fetchGacha = async () => {
    const api = createApiClientWithToken();
    const response = await api.findGacha(gachaId);

    setGacha(response);
  };

  useEffect(() => {
    fetchGacha();
  }, []);

  return (
    <GachaContext.Provider value={{ gacha, fetchGacha }}>{gacha ? children : <h1>Loading</h1>}</GachaContext.Provider>
  );
}
